export default "__VITE_ASSET__9620d053__"